import { shoppingApi } from 'app/src/services/welfareportal'
import { euroFormatter, formatDate } from 'app/src/shared/helpers'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { Dialog } from 'primereact/dialog'
import { ProgressSpinner } from 'primereact/progressspinner'
import type { ReactElement } from 'react'

export function WalletOverviewCreditInfoDialog(props: { onHide: () => void }): ReactElement {
  const creditNote = shoppingApi.useCreditNoteGet(
    {},
    {
      meta: {
        toastErrorMessage: 'Non è stato possibile recuperare le note di credito',
      },
    },
  )
  const { data, isPending, isError } = creditNote

  if (isError) return <></>

  return (
    <Dialog
      visible
      header={'Note di credito'}
      pt={{
        root: {
          className: 'max-w-[min(857px,85%)] md:min-w-[min(857px,85%)]',
        },
      }}
      onHide={() => props.onHide()}
    >
      {isPending ? (
        <div className='flex items-center justify-center p-4'>
          <ProgressSpinner data-testid='loading-element' className='h-16 w-16' />
        </div>
      ) : (
        <DataTable
          value={data?.note ?? []}
          className='w-full'
          pt={{
            header: { className: 'font-bold' },
            table: { tabIndex: 0 },
            root: { tabIndex: 0 },
          }}
        >
          <Column field='description' header={'Descrizione'}></Column>
          <Column
            field='Amount'
            header={'Importo'}
            body={(rowData) => euroFormatter.format(rowData.amount ?? 0)}
            pt={{
              bodyCell: { className: 'text-right' },
              headerCell: { className: 'flex justify-end' },
            }}
          ></Column>
          <Column field='Date' header={'Data'} body={(rowData) => formatDate(rowData.date ?? 0)}></Column>
        </DataTable>
      )}
    </Dialog>
  )
}
